import { EventEmitter } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, Observable } from 'rxjs';

export class GlobalEvent {
  private readonly emitter: EventEmitter<void> = new EventEmitter();

  public next(): void {
    this.emitter.next();
  }

  public observable(): Observable<void> {
    return this.emitter.pipe(takeUntilDestroyed(), debounceTime(50));
  }
}

export namespace Events {
  export const userModified: GlobalEvent = new GlobalEvent();
  export const colleaguesModified: GlobalEvent = new GlobalEvent();
}
